import React, { Component } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../actions';
import './SigninStyle.css';

class Signin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      signin: true,
      email: '',
      password: '',
      consent_given: false
    };
  }

  onSigninSubmit = async () => {
    const {email, password} = this.state;
    await this.props.login({ email, password, 'action': 'signin' });

    if(this.props.authenticated) {
      var {from} = this.props.location.state || {from: {pathname: '/'}};

      await Promise.all(
        [
          this.props.getUserPremiumStatus(),
          this.props.getStripeDetails(),
          this.props.getUserPersonalDetails()
        ]
      );
      this.props.history.push(from);
    } else {
      alert('An error occurred. Check your info and try again.')
    }
  };

  onSignupSubmit = async () => {
    const {email, password} = this.state;
    if(this.state.consent_given === false) {
      alert('Please acknowledge and agree to the eaterpad Terms and Conditions & Privacy Policy.');
    } else {
      await this.props.login({ email, password, 'action': 'signup' });

      if(this.props.authenticated) {
        var {from} = this.props.location.state || {from: {pathname: '/'}};

        await Promise.all(
          [
            this.props.getUserPremiumStatus(),
            this.props.getStripeDetails(),
            this.props.getUserPersonalDetails()
          ]
        );
        this.props.history.push(from);
      } else {
        alert('An error occurred. Check your info and try again.')
      }
    }
  };


  handleEmailChange = (event) => {
    this.setState({email: event.target.value});
  }

  handlePasswordChange = (event) => {
    this.setState({password: event.target.value});
  }

  handleConsentGivenChange = (event) => {
    this.setState({consent_given: event.target.value});
  }

  renderSignup = () => {
    return (
      <div className="flex-container" style={{ flexDirection: 'column', justifyContent: 'space-evenly'}}>
        <div className="flex-container box signin">
          <h1 className="signin-header" style={{ marginTop: '0px' }}>Sign Up</h1>
          <label className="signin-label">Email</label>
          <input
            name="email"
            type="text"
            value={this.state.email}
            onChange={this.handleEmailChange}
            component="input"
            autoComplete="none"
            className="signin-input"
          />
          <label className="signin-label" style={{ marginTop: '20px' }}>Password</label>
          <input
            name="password"
            type="password"
            value={this.state.password}
            onChange={this.handlePasswordChange}
            component="input"
            autoComplete="none"
            className="signin-input"
          />
          <div>{this.props.errorMessage}</div>
          <div className="signin-agreement" style={{ marginTop: '40px', display: 'flex' }}>
            <span style={{ marginRight: '5px', flex: 0}}>
              <input
                name="consent"
                type="checkbox"
                value={this.state.consent_given}
                onChange={this.handleConsentGivenChange}
                component="input"
                autoComplete="none"
                />
            </span>
            <span style={{ flex: 1 }}>
              I acknowledge and agree to the eaterpad <a href="https://www.eaterpad.com/policy.html">
                Terms and Conditions & Privacy Policy.
              </a>
            </span>
          </div>
          <button className="signin-button" style={{
            fontSize: '16px',
            height: '40px',
            margin: '10px',
            marginTop: '30px',
            backgroundColor: '#A6DD9D',
            color: 'black',
            width: '200px',
            cursor: 'pointer'}} onClick={this.onSignupSubmit}>
            Sign Up
          </button>
          <div style={{
            fontSize: '12px',
            margin: '10px',
            cursor: 'pointer'}} onClick={() => {this.setState({signin: true})}}>
            Sign In
          </div>
        </div>
      </div>
    );
  }

  renderSignin = () => {
    return (
      <div className="flex-container" style={{ flexDirection: 'column', justifyContent: 'space-evenly'}}>
        <div className="flex-container box signin">
          <h1 className="signin-header" style={{ marginTop: '0px' }}>Sign In</h1>
          <label className="signin-label">Email</label>
          <input
            name="email"
            type="text"
            value={this.state.email}
            onChange={this.handleEmailChange}
            component="input"
            autoComplete="none"
            className="signin-input"
          />
          <label className="signin-label" style={{ marginTop: '20px' }}>Password</label>
          <input
            name="password"
            type="password"
            value={this.state.password}
            onChange={this.handlePasswordChange}
            component="input"
            autoComplete="none"
            className="signin-input"
          />
          <div>{this.props.errorMessage}</div>
          <button className="signin-button" style={{
            fontSize: '16px',
            height: '40px',
            margin: '10px',
            marginTop: '50px',
            backgroundColor: '#A6DD9D',
            color: 'black',
            width: '200px',
            cursor: 'pointer'}} onClick={this.onSigninSubmit}>
            Sign In
          </button>
          <div style={{
            fontSize: '12px',
            margin: '10px',
            cursor: 'pointer'}} onClick={() => {this.setState({signin: false})}}>
            Sign Up
          </div>
        </div>
      </div>
    );
  }
  render() {
    return (
      <div className="flex-container" style={{ justifyContent: 'center' }}>
      { this.state.signin ? this.renderSignin() : this.renderSignup()}
      </div>
    )

  }
}

function mapStatetoProps(state) {
  return {
    errorMessage: state.auth.errorMessage,
    authenticated: state.auth.authenticated
  };
}

export default compose(
  connect(mapStatetoProps, actions)
)(Signin);
